__webpack_require__.p = "//samurai-hub-video-front-app.kimitsu.it-incubator.io/";